import React from 'react';
import BaseForm from "../forms/BaseForm";
import Input from "../forms/Input";


export default class ItemTextEditModal extends React.Component {

    static defaultProps = {
        items: []
    }

    constructor(props) {
        super(props);

        this.state = {
            itemVal: '',
            editing: false,
        }

    }


    handleAdditionSubmit = (e) => {
        if (e) e.preventDefault();
        this.props.onAdd(this.state.itemVal);
        this.setState({hasSearched: 1, itemVal: ''})
    }

    handleEditSubmit = (e) => {

    }

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success">
                        <h5 className={'title is-5 has-text-white-bis'}>{this.props.title}</h5>
                    </header>
                    <section className="modal-card-body">
                        <form onSubmit={this.handleAdditionSubmit} className={'mb-2'}>
                            <Input
                                type={'text'}
                                value={this.state.itemVal}
                                controlClasses={'full-width'}
                                placeholder={'Add here'}
                                disabled={this.props.disableSearch}
                                onChange={val => {
                                    this.setState({itemVal: val});
                                    //automatically clear the results if we have searched and then deleted the text
                                    if (!(val || val.length) && this.state.hasSearched) {
                                        this.props.handleSearch('');
                                        this.setState({hasSearched: 0});
                                    }
                                }}
                                addOns={[
                                        <button type={'submit'} className="button is-info">
                                            Add
                                        </button>
                                ]}
                            />
                        </form>

                        <div className={'y-overflow hide-scrollbars'}>
                            {this.props.items.map(d => (
                                <div className={'modal-list-item'}>
                                    <span>
                                        {d.text_value}
                                    </span>
                                    <span className={''}>
                                        {/*<span className={'icon has-text-primary'} onClick={() => {}}>*/}
                                        {/*    <i className={'far fa-edit'}/>*/}
                                        {/*</span>*/}
                                        <span className={'icon has-text-danger ml-2'} onClick={() => this.props.onDelete(d.id)}>
                                            <i className={'far fa-minus-square'}/>
                                        </span>
                                    </span>
                                </div>
                            ))}
                        </div>


                    </section>
                    <section className='modal-card-foot' style={{backgroundColor: 'white'}}>
                        <button className={'button is-info'} onClick={() => {
                            this.setState({itemVal: ''})
                            this.props.onCancel()
                        }}>Done</button>
                    </section>
                </div>
            </div>
        )
    }

}
